import React, { useState } from 'react';
import TextCard from '../Reusable/TextCard';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import CardSkeleton from '../Reusable/CardSkeleton';
import Template from '../Reusable/DataTable/loading';
import OrderList from './OrderList';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
const StatusList = (props: any) => {
  const {
    paynentMethodData,
    filterParams,
    register,
    isPaymentMethodLoading,
    setValue,
    selectedfilterParams,
    date,
    clientType,
  } = props;
  const [cardFilterParms, setCardFilterParms] = useState<any>();
  const [orderCount, setOrdercount] = useState(null);

  const [selectedPaymentMethod, setSelecteddPaymentMethod] = useState(null);

  return isPaymentMethodLoading ? (
    <>
      <div
        className={tw`grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 xl:grid-cols-4 gap-x-8`}
      >
        {Array.from({ length: 4 }).map((_, index) => {
          return <CardSkeleton key={index} />;
        })}
      </div>
      <Template addNewPath={false} />
    </>
  ) : (
    <>
      <div
        className={tw`grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 xl:grid-cols-4 gap-x-8`}
      >
        {paynentMethodData?.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <TextCard
              title={item?.name}
              slug={item?.id}
              setSelecteddPaymentMethod={setSelecteddPaymentMethod}
              count={item?.order_count}
              delivery_charge={item?.delivery_charge}
              cod={item?.cod}
              register={register('paymeny_method')}
              setValue={setValue}
              name={'paymeny_method'}
              selectedPaymentMethod={selectedPaymentMethod}
            />
          </React.Fragment>
        ))}
      </div>
      <OrderList
        setOrdercount={setOrdercount}
        clientType={clientType}
        filterParams={{
          ...filterParams,
          created__range: date,
          payment_method: selectedPaymentMethod,
          delivery_status__in: cardFilterParms ?? selectedfilterParams,
        }}
      />
    </>
  );
};

export default StatusList;
